var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.readyToView)?_c('div',[_c('h2',{staticClass:"card-title mb-0 pb-4"},[_vm._v(_vm._s(_vm.card.title))]),_c('apexchart',{attrs:{"type":"area","height":"350","options":_vm.chartOptions,"series":_vm.series}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }